<template>
    <v-dialog v-model="show" transition="dialog-bottom-transition" max-width="600">

        <template v-slot:activator="{ on, attrs }">
            <v-btn text class="mr-2" v-bind="attrs" v-on="on">
                <v-icon>
                    mdi-note-text
                </v-icon>
                Edit Info
            </v-btn>
        </template>

        <template>
            <v-overlay :absolute="absolute" :value="overlay">
                <v-card class="secondary px-4 py-4">

                    <v-row>
                        <v-col class="col-12 black--text text-center">

                            <v-icon size="50" color="primary">mdi-alert-circle</v-icon>
                            <p class="body-1 py-3">Opps something went wrong, please try again.</p>
                            <v-btn icon color="primary" @click="cancelError()">
                                <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-overlay>
            <v-card>
                <v-form ref="form" v-model="valid">
                    <v-card-text>
                        <div class="px-4 py-6">
                            <v-row>
                                <v-col class="col-12 text-center">
                                    <h1>Edit Subscriptions Details</h1>
                                </v-col>
                                <!-- <v-col class="col-12">
                                    <h2 class="mb-2">Company Info</h2>
                                    <v-divider></v-divider>
                                </v-col> -->
                                <v-col class="col-12 py-0">
                                    <v-text-field label="Company Name" v-model="subscription.company"></v-text-field>
                                </v-col>
                                <v-col class="col-12 py-0">
                                    <v-text-field label="Full Name" v-model="subscription.fullName"></v-text-field>
                                </v-col>
                                <!-- <v-col class="col-6 py-0">
                                    <v-text-field label="Last Name"></v-text-field>
                                </v-col> -->
                                <v-col class="col-6 py-0">
                                    <v-text-field label="Email Address" v-model="subscription.emailAddress"></v-text-field>
                                </v-col>
                                <v-col class="col-6 py-0">
                                    <v-text-field label="Mobile" v-model="subscription.mobile"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="col-6 text-center">
                                    <v-btn rounded @click="cancelOperation()" class="primary white--text">
                                        Cancel
                                    </v-btn>
                                </v-col>
                                <v-col class="col-6 text-center">
                                    <v-btn :loading="loading" :disabled="!valid" rounded @click="createDashboardUser()"
                                        class="primary white--text">
                                        Submit
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-form>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>

export default {
    props:['subscription'],
    data: () => ({
        overlay: false,
        absolute: true,
        show: false,
        dialog: false,
        successResponse: '',
        errorMessage: false,
        loading: false,
        valid: false,
        rules: { required: value => !!value || 'Required.' },
        emailRules: [v => !!v || "E-mail is required", v => /.+@.+\..+/.test(v) || "E-mail must be valid"],
    }),
    methods: {
        validate() {
            this.$refs.form.validate()
        },

        cancelError() {
            this.overlay = false
        },

        cancelOperation() {
            this.name = '',
                this.email = '',
                this.password = ''
            this.show = false
        },
    }
}
</script>

<style></style>